import Styles from './PostPreviewModal.module.scss'
import { Button } from 'blaze-ui/Button'
import { Calendar2, Send1 } from 'blaze-ui/icons'
import { PostStatusPropertyValue } from 'api/clients/PropertyClient'
import dayjs from 'dayjs'
import { useModals } from 'almanac-ui/Modal'
import { PostOptionsPage } from './Types'
import { usePostPreviewContext } from './PostPreviewContext'

export const ReminderButtons = () => {
  const { closeAllModals } = useModals()
  const { scheduledPost, setPage, dateTime, handleSetReminder, isPostable } = usePostPreviewContext()

  const onSetReminder = async () => {
    if (!dateTime) return
    await handleSetReminder(dateTime.toDate(), PostStatusPropertyValue.ReminderScheduled)
    closeAllModals()
  }

  if (!scheduledPost) return null

  return (
    <div className={Styles.postButtons}>
      <Button size="lg" variant="primary" frontIcon={Calendar2} onPress={onSetReminder} isDisabled={!isPostable}>
        Set Reminder for {dayjs(dateTime).format('MMM D h:mma')}
      </Button>
      <Button
        size="lg"
        variant="secondary"
        frontIcon={Send1}
        onPress={() => {
          setPage(PostOptionsPage.Schedule)
        }}
        isDisabled={!isPostable}
      >
        Schedule to Post
      </Button>
    </div>
  )
}
